module.exports = __webpack_public_path__ + "static/media/user-placeholder.295af695.png";